/**
 * ChatGPT Ads (OpenAI) pixel bridge. The SDK is installed once in public/index.html.
 * Conversions are decided server-side; the browser only adds its pixel copy using the
 * SAME event id the server used for its Conversions API call, so OpenAI dedupes them.
 */
import { api } from "@/lib/api";

const OPPREF_KEY = "pj_oppref";
const FIRED_KEY = "pj_oaiq_fired";

/** Persists the ChatGPT ad attribution value so a later signup/payment can still send it. */
export function oppref() {
  const fromUrl = new URLSearchParams(window.location.search).get("oppref");
  if (fromUrl) localStorage.setItem(OPPREF_KEY, fromUrl);
  return fromUrl || localStorage.getItem(OPPREF_KEY) || null;
}

const fired = () => {
  try {
    return JSON.parse(localStorage.getItem(FIRED_KEY)) || [];
  } catch {
    return [];
  }
};

/** True only the first time an event id is seen - survives refreshes, remounts and re-clicks. */
function claim(eventId) {
  const ids = fired();
  if (ids.includes(eventId)) return false;
  localStorage.setItem(FIRED_KEY, JSON.stringify([...ids, eventId].slice(-60)));
  return true;
}

function pixel(name, data, eventId) {
  if (typeof window.oaiq === "function") window.oaiq("measure", name, data, { event_id: eventId });
}

/** Pixel copy of a server-confirmed conversion. Returns false when it already fired. */
export function trackConversionPixel(name, data, eventId) {
  if (!eventId || !claim(eventId)) return false;
  pixel(name, data, eventId);
  return true;
}

let lastPath = null;

/** One page_viewed per route transition: pixel + CAPI with one shared event id. */
export function trackPageView(path, title) {
  if (lastPath === path) return; // React re-renders / duplicate effect runs
  lastPath = path;
  const eventId = `pv_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  const data = { type: "contents" };
  pixel("page_viewed", data, eventId);
  api
    .post("/marketing/oai/track", {
      event_name: "page_viewed",
      event_id: eventId,
      path,
      title: title || path,
      oppref: oppref(),
      source_url: window.location.href,
    })
    .catch(() => {});
}
